import { render, staticRenderFns } from "./ReTakeList.vue?vue&type=template&id=197efe9a&"
import script from "./ReTakeList.vue?vue&type=script&lang=js&"
export * from "./ReTakeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports